/*
 * Copyright (c) 2026. Orion Analytics. All Rights Reserved
 */

/*
 * Copyright (c) 2026. Orion Analytics.
 * All Rights Reserved.
 */

import Plot from "react-plotly.js";

export default function ClientTrendChart({

    trendData = []

}) {

    if (!trendData.length) {

        return (

            <div
                className="
                    bg-slate-950
                    border
                    border-slate-800
                    rounded-3xl
                    p-6
                    text-slate-400
                "
            >
                No historical positioning data available.
            </div>

        );

    }

    const clients = [

        ...new Set(
            trendData.map(
                d => d.client
            )
        )

    ];

    const traces = [];

    clients.forEach(client => {

        const rows = trendData

            .filter(
                d =>
                    d.client === client
            )

            .sort(
                (a, b) =>
                    new Date(a.oi_date) -
                    new Date(b.oi_date)
            );

        traces.push({

            x: rows.map(
                d => d.oi_date
            ),

            y: rows.map(
                d => d.total_long_oi
            ),

            type: "scatter",

            mode: "lines",

            name:
                `${client} Long`,

            line: {
                width: 3
            }

        });

        traces.push({

            x: rows.map(
                d => d.oi_date
            ),

            y: rows.map(
                d => d.total_short_oi
            ),

            type: "scatter",

            mode: "lines",

            name:
                `${client} Short`,

            line: {
                width: 2,
                dash: "dot"
            }

        });

    });

    return (

        <div
            className="
                bg-slate-950
                border
                border-slate-800
                rounded-3xl
                p-4
            "
        >

            {/* HEADER */}

            <div
                className="
                    mb-4
                "
            >

                <h2
                    className="
                        text-xl
                        font-semibold
                        text-white
                    "
                >
                    Client Positioning Trend
                </h2>

                <p
                    className="
                        text-sm
                        text-slate-400
                    "
                >
                    Evolution of Long and Short futures positions over time
                </p>

            </div>

            <Plot

                data={traces}

                layout={{

                    height: 600,

                    paper_bgcolor:
                        "#020617",

                    plot_bgcolor:
                        "#020617",

                    font: {
                        color:
                            "#cbd5e1"
                    },

                    margin: {
                        l: 70,
                        r: 30,
                        t: 20,
                        b: 60
                    },

                    xaxis: {

                        title:
                            "Date",

                        showgrid: false

                    },

                    yaxis: {

                        title:
                            "Open Interest",

                        gridcolor:
                            "#1e293b"

                    },

                    legend: {

                        orientation: "h",

                        y: 1.15,

                        x: 0

                    },

                    hovermode:
                        "x unified"

                }}

                config={{

                    responsive: true,

                    displayModeBar: false

                }}

                style={{
                    width: "100%"
                }}

            />

            <div
                className="
                    mt-3
                    text-xs
                    text-slate-500
                "
            >
                Solid lines represent Long OI.
                Dotted lines represent Short OI.
            </div>

        </div>

    );

}